// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/5763aabe9487ea814fe0.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"910bba7182c4c6b70d95","216":"c411fe352eb5320d381f","217":"a5975d5f90ff690af061"}[chunkId] + ".chunk.js";
};